import { AdvantagesBlock } from "../../../types";

interface AdvantagesProps {
  block: AdvantagesBlock;
}

export default function Advantages({ block }: AdvantagesProps) {
  return (
    <div className="bg-white py-16">
      <div className="max-w-[85rem] px-4 md:py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
        {block.title && (
          <h2 className="font-semibold text-dark-100 font-serif text-3xl text-center mb-10">
            {block.title}
          </h2>
        )}
        <div className="md:flex flex-wrap justify-center gap-8">
          {block.items &&
            block.items.map((item, index) => (
              <div
                key={index}
                className="py-6 px-4 md:max-w-[20rem] h-full text-center flex flex-col items-center justify-start min-w-[10rem]"
              >
                {item.icon?.asset?.url && (
                  <img
                    className="size-12"
                    src={item.icon.asset.url}
                    alt={item.icon.alt || item.title}
                  />
                )}
                <h3 className="pb-2 pt-5 font-semibold text-[1.35rem] text-dark-100 font-serif">
                  {item.title}
                </h3>
                <p className="text-dark-200 ">{item.description}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
